import MetaModel from "./MetaModel";

export default class PaginationModel {
    public meta: MetaModel = new MetaModel();
    public data: any[] = [];
}